export const SharePointConsts = {
    acceptVerbose: "application/json; odata=verbose",
    acceptNoMetadata: "application/json; odata=nometadata",
    contentTypeVerbose: "application/json; odata=verbose",
    contentTypeNoMetadata: "application/json; odata=nometadata"
}